import { ICommitDeliveryInput } from 'generated/rbi-graphql';
import { IUseCartTip } from 'state/order/hooks/use-cart-tip';
import { ServiceMode } from 'state/service-mode';
import { IPlaceAddress } from 'utils/geolocation';

interface IBuildCommitDeliveryInput {
  deliveryAddress: IPlaceAddress | null;
  deliveryInstructions?: string;
  phoneNumber: string;
  serviceMode: ServiceMode;
  tipAmount: IUseCartTip['tipAmount'];
}

export const buildCommitDeliveryInput = ({
  deliveryAddress,
  deliveryInstructions,
  phoneNumber,
  serviceMode,
  tipAmount,
}: IBuildCommitDeliveryInput): ICommitDeliveryInput | null => {
  if (serviceMode !== ServiceMode.DELIVERY || !deliveryAddress) {
    return null;
  }

  return {
    instructions: deliveryInstructions,
    tipCents: tipAmount,
    pushNotification: true,
    dropoff: {
      ...deliveryAddress,
      phoneNumber,
    },
  };
};
